import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const BlackHoleEatAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const pInv = 1 - progress;
  const swirl = progress * Math.PI * 10;
  for (let i = 0; i < 20; i++) {
    const baseAng = (i / 20) * Math.PI * 2;
    const ang = baseAng + swirl;
    const distBase = e.maxRadius * pInv;
    const r = getRadiusAtAngle(ang, e, distBase);
    ctx.beginPath(); ctx.arc(e.pos.x + Math.cos(ang) * r, e.pos.y + Math.sin(ang) * r, 8 * pInv, 0, Math.PI * 2); ctx.fill();
  }
};

registerBlastAnimation('BLACK_HOLE_EAT', BlackHoleEatAnimation);
